/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：営業所選択プルダウン関連のサービス
 *
 * 作成者：2022/3/30 ノア）黄
 * 最終修正者：2022/3/30 ノア）黄
 *
 */

/**
 * 営業所選択プルダウン関連のサービス
 *
 * @class
 */
class GlobalOfficeService {
  // 営業所選択ポップアップでいいえの場合、trueにする
  // trueの場合、マスタ画面は営業所変更をチェックしないようにする
  allowGlobalOfficeChange = false

  /**
   * 営業所変更まえの処理
   *
   * @param {any} next 次の処理
   * @returns {void}
   */
  // eslint-disable-next-line
  beforeGlobalOfficeChange: ((next: any) => Promise<void> | undefined) | undefined

  /**
   * 営業所変更チェックフラグをリセットする
   *
   * @returns {void}
   */
  resetAllowGlobalOfficeChangeFlag(): void {
    this.allowGlobalOfficeChange = false
  }
}

export const globalOfficeService = new GlobalOfficeService()
